import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import View from '../view';
import Text from '../text';
import { pxTransform } from '../../common/utils';

interface IProgressProps {
  /**
   * css class
   */
  className?: string;
  /**
   * 颜色，默认取 scss 变量 $ink-progress-bar-bg-color
   */
  color?: string;
  /**
   * 状态
   * @default 'progress'
   */
  status?: 'progress' | 'success' | 'error';
  /**
   * 进度百分比
   */
  percent: number | string;
  /**
   * 规格，默认取 scss 变量 $ink-progress-height; 此属性传入值为 number 时, 调用 Taro.pxTransform(size, 750) 计算尺寸;
   */
  strokeWidth?: number | string;
  /**
   * 进度文字组件
   */
  pivot?: ReactNode;
  /**
   * 是否显示进度文字
   * @default true
   */
  showPivot?: boolean;
}

const Progress: FC<IProgressProps> = ({ className = '', color, status = 'progress', percent, strokeWidth, pivot, showPivot = true }) => {
  const rootClass = classNames('ink-progress', { [`ink-progress--${status}`]: !!status }, className);
  const progressStyle = {
    width: percent && `${+percent}%`,
    height: strokeWidth && (typeof strokeWidth === 'number' ? pxTransform(strokeWidth) : strokeWidth),
    backgroundColor: color,
  };
  const iconClass = classNames('ink-icon', {
    'ink-icon-close-circle': status === 'error',
    'ink-icon-check-circle': status === 'success',
  });

  return (
    <View className={rootClass}>
      <View className="ink-progress__inner">
        <View className="ink-progress__inner-background" style={progressStyle} />
      </View>
      {showPivot && (pivot || <View className="ink-progress__privot">{status === 'progress' ? `${percent}%` : <Text className={iconClass} />}</View>)}
    </View>
  );
};

export default Progress;
